module.exports = __webpack_public_path__ + "static/media/iconComplaint.ad3daf02.svg";